import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Interceptor de cache HTTP.
 * Não adiciona headers anti-cache para não forçar round-trips desnecessários.
 * O servidor controla a validade dos dados via Cache-Control próprio.
 */
export const cacheInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  return next(request);
};
